
import { motion } from "framer-motion";
import { Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const testimonials = [
  "Exceptional in every way",
  "Our only regret during our stay was sleeping through an amazing Aurora Australis",
  "The house has incredible views, is well equipped and provides everything needed",
  "What a beautiful place to escape the world. Peaceful surroundings full of wildlife",
  "It's the most beautiful, serene location with a stunning outlook.",
  "Goodness, where to start! incredibly beautiful setting. So peaceful.",
  "Flowerpot Cottage was an absolutely delightful and luxurious experience",
  "The house is absolutely immaculate",
  "Resting in the bath looking out over the D'Entrecasteau channel is not to be missed!",
  "This is a gorgeous property in a stunning location.",
];

const TestimonialsSection = () => {
  return (
    <section className="py-16 md:py-24 px-6 bg-secondary/50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex items-center justify-center gap-2 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} className="fill-cottage-700 text-cottage-700" />
            ))}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
            5.0 · 10 Guest Reviews
          </h2>
          <p className="text-muted-foreground">
            What our guests say about their stay
          </p>
        </motion.div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {testimonials.map((quote, index) => (
            <motion.blockquote
              key={index}
              className="break-inside-avoid bg-card border border-border rounded-xl p-5 inline-block w-full"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <p className="text-foreground italic leading-relaxed">
                "{quote}"
              </p>
            </motion.blockquote>
          ))}
        </div>

        <motion.div
          className="text-center mt-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Link
            to="/reviews"
            className="inline-flex items-center gap-2 text-cottage-700 hover:text-cottage-900 font-medium transition-colors"
          >
            Read all reviews
            <ArrowRight size={18} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
